import type { ComponentPropsWithoutRef } from "react";
import classNames from "classnames";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import {
  CANVAS_SIZE_ID,
  DESKTOP_WIDTH,
  MOBILE_WIDTH,
  TABLET_WIDTH,
} from "./constants";

export interface CanvasSizeProps extends ComponentPropsWithoutRef<"div"> {
  desktopWidth?: number;
  mobileWidth?: number;
  tabletWidth?: number;
}

export const CanvasSize = ({
  children,
  className,
  mobileWidth = MOBILE_WIDTH,
  tabletWidth = TABLET_WIDTH,
  desktopWidth = DESKTOP_WIDTH,
  ...rest
}: CanvasSizeProps) => {
  const canvasSize = useBuilderStore(state => state.canvasSize);

  let width = desktopWidth;
  if (canvasSize === "mobile") width = mobileWidth;
  if (canvasSize === "tablet") width = tabletWidth;

  return (
    <div className="h-full overflow-x-auto" data-testid="canvas-size-container">
      <div
        id={CANVAS_SIZE_ID}
        className={classNames("mx-auto h-full", className)}
        style={{ width: `${width}px` }}
        data-testid="canvas-size"
        {...rest}
      >
        {children}
      </div>
    </div>
  );
};
